import { uniqueId } from "lodash";
import {
  IconUserCircle,
  IconLayoutDashboard,
  IconStethoscope,
  IconBuildingHospital,
  IconCalendarStats,
  IconClipboardList,
  IconUserCheck,
  IconCalendar,
  IconClipboardCheck,
  IconHeart,
  IconSettings,
  IconUsers,
  IconHome,
  IconPhoneCall,
} from "@tabler/icons";

interface MenuitemsType {
  [x: string]: any;
  id?: string;
  navlabel?: boolean;
  subheader?: string;
  title?: string;
  icon?: any;
  href?: string;
  children?: MenuitemsType[];
  chip?: string;
  chipColor?: string;
  variant?: string;
  external?: boolean;
}

// 메뉴 항목 정의
export const Menuitems: MenuitemsType[] = [
  {
    id: uniqueId(),
    title: "대쉬보드",
    icon: IconHome,
    children: [
      {
        id: uniqueId(),
        title: "진료예약 현황",
        icon: IconLayoutDashboard,
        href: "/dashboard",
      },
      {
        id: uniqueId(),
        title: "도수치료 예약 현황",
        icon: IconLayoutDashboard,
        href: "/dashboard-2",
      },
      // {
      //   id: uniqueId(),
      //   title: "대쉬보드",
      //   icon: IconLayoutDashboard,
      //   href: "/dashboard-3",
      // },
    ],
  },
  {
    id: uniqueId(),
    title: "의사관리",
    icon: IconUserCircle,
    children: [
      {
        id: uniqueId(),
        title: "의사관리",
        icon: IconStethoscope,
        href: "/doctorList",
      },
      {
        id: uniqueId(),
        title: "도수치료사관리",
        icon: IconBuildingHospital,
        href: "/maunalTheraistList",
      },
    ],
  },
  {
    id: uniqueId(),
    title: "진료예약관리",
    icon: IconCalendarStats,
    children: [
      {
        id: uniqueId(),
        title: "예약관리",
        icon: IconClipboardList,
        href: "/reservation",
      },
      {
        id: uniqueId(),
        title: "의료진별 예약관리",
        icon: IconUserCheck,
        href: "/doctorByReservation",
      },
    ],
  },
  {
    id: uniqueId(),
    title: "도수치료 예약관리",
    icon: IconCalendar,
    children: [
      {
        id: uniqueId(),
        title: "예약관리",
        icon: IconClipboardCheck,
        href: "/maunalTheraistReservation",
      },
      {
        id: uniqueId(),
        title: "치료사별 예약관리",
        icon: IconHeart,
        href: "/maunalTheraistByReservation",
      },
    ],
  },
  {
    id: uniqueId(),
    title: "유저관리",
    icon: IconSettings,
    children: [
      {
        id: uniqueId(),
        title: "회원관리",
        icon: IconUsers,
        href: "/userManagement",
      },
      {
        id: uniqueId(),
        title: "환자관리",
        icon: IconPhoneCall,
        href: "/appUserManagement",
      },
    ],
  },
];
